import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { fmtJourneyDate } from "@/lib/content";

export function LastHorizonKeyDates({ variant = "default" }) {
  const { data: status } = useQuery({ queryKey: ["last-horizon-status"], queryFn: async () => (await api.get("/last-horizon/status")).data });
  if (!status) return null;
  const dates = [
    ["Applications Open", status.application_open_date],
    ["Last Date to Apply", status.application_close_date],
    ["Results Announced", status.announcement_date],
    ["Departure to Kaziranga", status.kaziranga_start],
  ].filter(([, d]) => d);
  if (!dates.length) return null;
  return (
    <div data-testid="last-horizon-key-dates" className={`grid grid-cols-2 sm:grid-cols-4 border border-ptf-primary/12 divide-x divide-y sm:divide-y-0 divide-ptf-primary/10 ${variant === "muted" ? "bg-ptf-bg" : "bg-white"}`}>
      {dates.map(([label, d]) => (
        <div key={label} className="p-4 text-center">
          <p className="text-[0.58rem] uppercase tracking-[0.14em] text-ptf-text/50 mb-1">{label}</p>
          <p className="font-display text-sm text-ptf-primary">{fmtJourneyDate(d)}</p>
        </div>
      ))}
    </div>
  );
}
